import cloneDeep from 'lodash/cloneDeep'
import React, { useEffect, useState } from 'react'
import { Group, Rect, Text } from 'react-konva'

interface Filter {
    type: string
    viewModeId: string
    properties: {
        _rectangle_in?: {
            _x0: number
            _y0: number
            _x1: number
            _y1: number
        }
        _rectangle_out?: {
            _x0: number
            _y0: number
            _x1: number
            _y1: number
        }
        _rectangle_in_out?: {
            _x0: number
            _y0: number
            _x1: number
            _y1: number
        }
    }
}

function normalizeFilters(filteredFilters: Filter[], imageWidth: number, imageHeight: number) {
    return filteredFilters.map((filter) => {
        const normalizedFilter = cloneDeep(filter)

        if (filter.properties._rectangle_in) {
            const rectIn = filter.properties._rectangle_in
            normalizedFilter.properties._rectangle_in = {
                ...rectIn,
                _x0: (rectIn._x0 / imageWidth) * 750,
                _x1: (rectIn._x1 / imageWidth) * 750,
                _y0: (rectIn._y0 / imageHeight) * (750 * (imageHeight / imageWidth)),
                _y1: (rectIn._y1 / imageHeight) * (750 * (imageHeight / imageWidth))
            }
        }

        if (filter.properties._rectangle_out) {
            const rectOut = filter.properties._rectangle_out
            normalizedFilter.properties._rectangle_out = {
                ...rectOut,
                _x0: (rectOut._x0 / imageWidth) * 750,
                _x1: (rectOut._x1 / imageWidth) * 750,
                _y0: (rectOut._y0 / imageHeight) * (750 * (imageHeight / imageWidth)),
                _y1: (rectOut._y1 / imageHeight) * (750 * (imageHeight / imageWidth))
            }
        }

        if (filter.properties._rectangle_in_out) {
            const rectInOut = filter.properties._rectangle_in_out
            normalizedFilter.properties._rectangle_in_out = {
                ...rectInOut,
                _x0: (rectInOut._x0 / imageWidth) * 750,
                _x1: (rectInOut._x1 / imageWidth) * 750,
                _y0: (rectInOut._y0 / imageHeight) * (750 * (imageHeight / imageWidth)),
                _y1: (rectInOut._y1 / imageHeight) * (750 * (imageHeight / imageWidth))
            }
        }

        return normalizedFilter
    })
}

const ViewLayerFilter: React.FC<{
    imageSize: any
    viewConfig: any
}> = (props) => {
    const [viewConfig, setViewConfig] = useState<any>([])

    useEffect(() => {
        const normalizedConfig = normalizeFilters(props.viewConfig, 1920, 1080)
        setViewConfig(normalizedConfig)
    }, [props.viewConfig, props.imageSize.width, props.imageSize.height])

    return (
        <Group name="polygon" preventDefault={false}>
            {viewConfig.map((filter: Filter, index: React.Key | null | undefined) => {
                if (filter.type === 'FilterInvalidTrajectory_Double') {
                    if (filter.properties._rectangle_in_out) {
                        const rectInOut = filter.properties._rectangle_in_out
                        const viewModeId = filter.viewModeId

                        return (
                            <React.Fragment key={index}>
                                <Rect
                                    x={rectInOut._x0}
                                    y={rectInOut._y0}
                                    width={rectInOut._x1 - rectInOut._x0}
                                    height={rectInOut._y1 - rectInOut._y0}
                                    stroke="rgba(255, 165, 0, 1)"
                                    strokeWidth={2}
                                    fill="grey"
                                    opacity={0.5}
                                />
                                <Text
                                    x={rectInOut._x0 + 5}
                                    y={rectInOut._y0 + 5}
                                    text={`IN/OUT ${viewModeId}`}
                                    fill="white"
                                    fontFamily="Albert Sans, sans-serif"
                                />
                            </React.Fragment>
                        )
                    }
                } else if (
                    filter.type === 'FilterInvalidTrajectory_Soft' ||
                    filter.type === 'ClassifyDirection_IN_Soft' ||
                    filter.type === 'ClassifyDirection_OUT_Soft'
                ) {
                    const rectIn = filter.properties._rectangle_in
                    const rectOut = filter.properties._rectangle_out
                    const viewModeId = filter.viewModeId

                    return (
                        <React.Fragment key={index}>
                            {rectIn && (
                                <React.Fragment>
                                    <Rect
                                        x={rectIn._x0}
                                        y={rectIn._y0}
                                        width={rectIn._x1 - rectIn._x0}
                                        height={rectIn._y1 - rectIn._y0}
                                        stroke="rgba(0, 255, 0, 1)"
                                        strokeWidth={2}
                                        fill="grey"
                                        opacity={0.5}
                                    />
                                    <Text
                                        x={rectIn._x0 + 5}
                                        y={rectIn._y0 + 5}
                                        text={`IN ${viewModeId}`}
                                        fill="white"
                                        fontFamily="Albert Sans, sans-serif"
                                    />
                                </React.Fragment>
                            )}
                            {rectOut && (
                                <React.Fragment>
                                    <Rect
                                        x={rectOut._x0}
                                        y={rectOut._y0}
                                        width={rectOut._x1 - rectOut._x0}
                                        height={rectOut._y1 - rectOut._y0}
                                        stroke="rgba(255, 0, 0, 1)"
                                        strokeWidth={2}
                                        fill="grey"
                                        opacity={0.5}
                                    />
                                    <Text
                                        x={rectOut._x0 + 5}
                                        y={rectOut._y0 + 5}
                                        text={`OUT ${viewModeId}`}
                                        fill="white"
                                        fontFamily="Albert Sans, sans-serif"
                                    />
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )
                }
                console.log('INVALID FILTER TYPE: ', filter.type)
                return null
            })}
        </Group>
    )
}

export default ViewLayerFilter
